/**
 * Created by andrey on 21.01.2021.
 */

const EditorLayoutControls = cleverapps.Layout.extend({
    ctor: function (callback) {
        const config = [
            { icon: bundles.admin.frames.left_double, delta: -2 },
            { icon: bundles.admin.frames.left, delta: -1 },
            { icon: bundles.admin.frames.right, delta: 1 },
            { icon: bundles.admin.frames.right_double, delta: 2 }
        ];

        const buttons = config.map(function (info) {
            return AdminDetailControls.prototype.createButton.call(this, {
                icon: info.icon,
                action: callback.bind(this, info.delta)
            });
        }, this);

        buttons.push(AdminDetailControls.prototype.createButton.call(this, {
            icon: bundles.admin.frames.enlarge_button,
            action: function () {
                const size = LevelManager.getInstance().level.content.map.length;
                const res = window.prompt("Specify map size;dx;dy", `${size};0;0`);
                if (!res) {
                    return;
                }
                const parts = res.split(";");
                const newSize = parseInt(parts[0]);
                const dx = parts[1] && parseInt(parts[1]) || 0;
                const dy = parts[2] && parseInt(parts[2]) || 0;

                if (newSize < 10 || newSize > 80) {
                    cleverapps.notification.create("Size must be in 10..80 interval");
                    return;
                }

                if (Math.abs(dx) > newSize / 2 || Math.abs(dy) > newSize / 2) {
                    cleverapps.notification.create("dx or dy bigger then half of newSize");
                    return;
                }

                Editor.currentEditor.doCommand("changeMapSize", {
                    newSize, dx, dy
                });

                cleverapps.refreshScene();
            }
        }));

        this._super(buttons, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.EditorLayoutControls.margin
        });

        this.setAlignment(cleverapps.styles.EditorLayoutControls.position);
    }
});

cleverapps.styles.EditorLayoutControls = {
    button: {
        width: 60,
        height: 60
    },
    margin: 10,
    position: {
        x: { align: "right", dx: -350 },
        y: { align: "top", dy: -20 }
    }
};